/**
 * @generated SignedSource<<40f97f46e67e958ba8a5eecbbe2157e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamTeamSchedulePreview_team$data = {
  readonly color: string | null;
  readonly dailySchedule: {
    readonly events: ReadonlyArray<{
      readonly __typename: string;
      readonly assigned?: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly assignedRoles?: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly id: string;
      readonly routine?: {
        readonly description: string | null;
        readonly descriptionImages: ReadonlyArray<{
          readonly __typename: "Image";
        }>;
      };
      readonly startAt: string;
      readonly taskExecution?: {
        readonly routineOccasion: {
          readonly assigned: ReadonlyArray<{
            readonly id: string;
          }>;
          readonly assignedRoles: ReadonlyArray<{
            readonly id: string;
          }>;
          readonly routine: {
            readonly description: string | null;
            readonly descriptionImages: ReadonlyArray<{
              readonly __typename: "Image";
            }>;
          };
        };
      };
      readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleListItem_TeamScheduleEventOccasion">;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleSectionHeaderSummary_teamSchedule">;
  };
  readonly id: string;
  readonly monthlySchedule: {
    readonly events: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleSectionHeaderSummary_teamSchedule">;
  };
  readonly weeklySchedule: {
    readonly events: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleSectionHeaderSummary_teamSchedule">;
  };
  readonly " $fragmentType": "TeamTeamSchedulePreview_team";
};
export type TeamTeamSchedulePreview_team$key = {
  readonly " $data"?: TeamTeamSchedulePreview_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamTeamSchedulePreview_team">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "TeamScheduleSectionHeaderSummary_teamSchedule"
},
v2 = [
  {
    "kind": "Literal",
    "name": "includeInlineRoutines",
    "value": true
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = [
  (v0/*: any*/)
],
v5 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Routine",
    "kind": "LinkedField",
    "name": "routine",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Image",
        "kind": "LinkedField",
        "name": "descriptionImages",
        "plural": true,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "AssignedEmployee",
    "kind": "LinkedField",
    "name": "assigned",
    "plural": true,
    "selections": (v4/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "AssignedRole",
    "kind": "LinkedField",
    "name": "assignedRoles",
    "plural": true,
    "selections": (v4/*: any*/),
    "storageKey": null
  }
],
v6 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": (v2/*: any*/),
    "concreteType": null,
    "kind": "LinkedField",
    "name": "events",
    "plural": true,
    "selections": (v4/*: any*/),
    "storageKey": "events(includeInlineRoutines:true)"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamTeamSchedulePreview_team",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": "dailySchedule",
      "args": [
        {
          "kind": "Literal",
          "name": "freq",
          "value": "DAILY"
        }
      ],
      "concreteType": "TeamSchedule",
      "kind": "LinkedField",
      "name": "currentTeamSchedule",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": (v2/*: any*/),
          "concreteType": null,
          "kind": "LinkedField",
          "name": "events",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startAt",
              "storageKey": null
            },
            (v0/*: any*/),
            (v3/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": (v5/*: any*/),
              "type": "RoutineOccasion",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TaskExecutionCheck",
                  "kind": "LinkedField",
                  "name": "taskExecution",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RoutineOccasion",
                      "kind": "LinkedField",
                      "name": "routineOccasion",
                      "plural": false,
                      "selections": (v5/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "TeamScheduleInlineRoutineOccasion",
              "abstractKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TeamScheduleListItem_TeamScheduleEventOccasion"
            }
          ],
          "storageKey": "events(includeInlineRoutines:true)"
        }
      ],
      "storageKey": "currentTeamSchedule(freq:\"DAILY\")"
    },
    {
      "alias": "weeklySchedule",
      "args": [
        {
          "kind": "Literal",
          "name": "freq",
          "value": "WEEKLY"
        }
      ],
      "concreteType": "TeamSchedule",
      "kind": "LinkedField",
      "name": "currentTeamSchedule",
      "plural": false,
      "selections": (v6/*: any*/),
      "storageKey": "currentTeamSchedule(freq:\"WEEKLY\")"
    },
    {
      "alias": "monthlySchedule",
      "args": [
        {
          "kind": "Literal",
          "name": "freq",
          "value": "MONTHLY"
        }
      ],
      "concreteType": "TeamSchedule",
      "kind": "LinkedField",
      "name": "currentTeamSchedule",
      "plural": false,
      "selections": (v6/*: any*/),
      "storageKey": "currentTeamSchedule(freq:\"MONTHLY\")"
    }
  ],
  "type": "Team",
  "abstractKey": null
};
})();

(node as any).hash = "403ff178737df45b4eea78e23316a5ac";

export default node;
